export enum GameFont {
    DEFAULT_FONT = "BebasNeuePro Bold",
    DEFAULT_FONT_REGULAR = "BebasNeuePro Regular",
    Bebasneuepro_Smerg = "Bebasneuepro Smerg",
    BEBAS_NEUE_PRO_SMERG_BOLD = "Bebasneuepro Smebd"
}